export default __webpack_public_path__ + "static/media/11.dc6cf0c7.png";